import { render, staticRenderFns } from "./schoolGoodsStudent.vue?vue&type=template&id=685ac3c2"
import script from "./schoolGoodsStudent.vue?vue&type=script&lang=js"
export * from "./schoolGoodsStudent.vue?vue&type=script&lang=js"
import style0 from "./schoolGoodsStudent.vue?vue&type=style&index=0&id=685ac3c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports